'use strict';

const { HIDDEN_CLASS, EMPTY_STRING } = require('../../constants');
const { injectMessageAndUpdateElementState } = require('./messagingUtil');
const { queryFirst, addClass, removeClass } = require('../../domUtil');

const ISPU_DELIVERY_MESSAGE_SELECTOR = '.ispu-delivery-estimation-message';

/**
 * Function to get ISPU delivery message element (e.g., Order by X pm Get it by Y pm)
 * @param {HTMLElement} productContainer - Product container Element
 * @returns {HTMLElement} ISPU non-availability element
 */
function getISPUDeliveryMessageEl(productContainer) {
    return queryFirst(ISPU_DELIVERY_MESSAGE_SELECTOR, productContainer);
}

/**
 * Function to inject ISPU delivery estimation message in product container
 * @param {string} message - ISPU delivery estimation message
 * @param {HTMLElement} productContainer - Product container Element
 */
function injectISPUDeliveryMessage(message, productContainer) {
    const ispuDeliveryMessageEl = getISPUDeliveryMessageEl(productContainer);
    injectMessageAndUpdateElementState(ispuDeliveryMessageEl, message);
}

/**
 * Function to remove ISPU delivery estimation message from product container
 * @param {HTMLElement} productContainer - Product container Element
 */
function clearISPUDeliveryMessage(productContainer) {
    const ispuDeliveryMessageEl = getISPUDeliveryMessageEl(productContainer);
    injectMessageAndUpdateElementState(ispuDeliveryMessageEl, EMPTY_STRING);
}

/**
 * Function to show ISPU delivery estimation message from product container
 * @param {HTMLElement} productContainer - Product container Element
 */
function showISPUDeliveryMessage(productContainer) {
    const ispuDeliveryMessageEl = getISPUDeliveryMessageEl(productContainer);
    removeClass(ispuDeliveryMessageEl, HIDDEN_CLASS);
}

/**
 * Function to hide ISPU delivery estimation message from product container
 * @param {HTMLElement} productContainer - Product container Element
 */
function hideISPUDeliveryMessage(productContainer) {
    const ispuDeliveryMessageEl = getISPUDeliveryMessageEl(productContainer);
    addClass(ispuDeliveryMessageEl, HIDDEN_CLASS);
}

module.exports = {
    getISPUDeliveryMessageEl,
    injectISPUDeliveryMessage,
    clearISPUDeliveryMessage,
    showISPUDeliveryMessage,
    hideISPUDeliveryMessage
};
